import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import { IntegrationData } from '../../integrations/types';
import { NewIntegration } from '../../saveIntegration/types';

export class SaveIntegrationDataProvider extends BaseWebComponentDataProvider {
  public async createRecords(records: NewIntegration[]): Promise<any> {
    return ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'IntegrationInstances',
      method: 'createRecords',
      payload: {
        records: records,
      },
    });
  }

  public async getIntegrationById(integrationId: string | null): Promise<IntegrationData<unknown>> {
    let response;

    console.log('integrationId in data provider', integrationId);
    try {
      response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.ENDPOINTS,
        endpoint: 'IntegrationInstances',
        method: 'getById',
        payload: { id: integrationId },
      });
    } catch (e) {
      console.error(e);
      throw e;
    }

    if (!response || !response.success || !response.data) {
      throw new Error('No edited integration data');
    }

    return response.data;
  }

  getDataForView() {}
}
